<div *ngIf="!showDatePicker && type" style="margin-left: 12px;" class="cool-date-picker-trigger" (click)="toggleDatePicker(showDatePicker)">選擇日期</div>
<div *ngIf="showDatePicker && type" style="margin-left: 12px;" class="cool-date-picker-trigger-cancel" (click)="toggleDatePicker(showDatePicker)">取消日期</div>
<div *ngIf="(showDatePicker && type) || !type" style="display: inline-block;">
    <input type="text"
    #dateInput
    *ngIf="time"
    class="form-control"
    ngxDaterangepickerMd
    [(ngModel)]="time"
    [autoApply]="auto"
    [ranges]="ranges"
    [alwaysShowCalendars]="true"
    [locale]="{ applyLabel: 'ok', format: format}"
    [timePicker]="timePickerSeconds"
    [timePickerSeconds]="timePickerSeconds"
    [opens]="'right'"
    [minDate]="minSelectable"
    [maxDate]="maxSelectable"
    (change)="onRangeSelected($event)"
    (keydown.enter)="handleManualInput($event)"
    (blur)="handleManualInput($event)"
    [style]="css"
    >
</div>